import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import { CATALOG_FILTERS_SUBCOLLECTION } from '../constants/productCatalogFilters';
import { parseProductFilterKey } from './productCatalogFilterKeys';

async function addCardToProductFilter({ collectionName, docId, filterId, categoryId, cardId }) {
  const filterRef = doc(
    firestore,
    collectionName,
    docId,
    CATALOG_FILTERS_SUBCOLLECTION,
    filterId
  );
  const snap = await getDoc(filterRef);
  if (!snap.exists()) return;

  const data = snap.data();
  const alreadyLinked = (data.cardEntries || []).some(
    (entry) => entry.categoryId === categoryId && entry.cardId === cardId
  );
  if (alreadyLinked) return;

  await updateDoc(filterRef, {
    cardEntries: [...(data.cardEntries || []), { categoryId, cardId }],
  });
}

async function removeCardFromProductFilter({ collectionName, docId, filterId, categoryId, cardId }) {
  const filterRef = doc(
    firestore,
    collectionName,
    docId,
    CATALOG_FILTERS_SUBCOLLECTION,
    filterId
  );
  const snap = await getDoc(filterRef);
  if (!snap.exists()) return;

  const data = snap.data();
  const cardEntries = (data.cardEntries || []).filter(
    (entry) => !(entry.categoryId === categoryId && entry.cardId === cardId)
  );

  await updateDoc(filterRef, { cardEntries });
}

/**
 * Mantém paridade bidirecional com Produtos → Filtros:
 * `cardEntries` no doc em `{collection}/{docId}/catalogFilters/{filterId}`.
 */
export async function syncProductFilterLinks({
  categoryId,
  cardId,
  previousKeys = [],
  nextKeys = [],
}) {
  if (!categoryId || !cardId) return;

  const prev = new Set(previousKeys.filter(Boolean));
  const next = new Set(nextKeys.filter(Boolean));
  const toAdd = [...next].filter((key) => !prev.has(key));
  const toRemove = [...prev].filter((key) => !next.has(key));

  if (toAdd.length === 0 && toRemove.length === 0) return;

  const ops = [];

  for (const key of toRemove) {
    const parsed = parseProductFilterKey(key);
    if (!parsed) continue;
    ops.push(
      removeCardFromProductFilter({
        ...parsed,
        categoryId,
        cardId,
      })
    );
  }

  for (const key of toAdd) {
    const parsed = parseProductFilterKey(key);
    if (!parsed) continue;
    ops.push(
      addCardToProductFilter({
        ...parsed,
        categoryId,
        cardId,
      })
    );
  }

  await Promise.all(ops);
}
